import { TableContainer } from "@chakra-ui/react";
import React from "react";

import styles from "./TableContent.module.scss";

interface TableContentProps {
  field: {
    columns: string[];
    rows: (string | number)[][];
  };
}

const TableContent: React.FC<TableContentProps> = ({ field }) => {
  return (
    <TableContainer className={styles.tableContainer}>
      <div className={styles.table}>
        <table>
          <thead className={styles.tableHead}>
            <tr>
              {field.columns.map((col, index) => (
                <th key={index} scope="col" className={styles.tableCellHeader}>
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody data-testid="table-body">
            {field.rows.map((row, rowIndex) => (
              <tr key={rowIndex} className={styles.tableRow}>
                {row.map((cell, cellIndex) => {
                  return (
                    <td
                      key={cellIndex}
                      className={`${styles.tableCell}`}
                      style={{ borderBottom: "1px solid transparent" }}
                    >
                      {cell}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </TableContainer>
  );
};

export default TableContent;
